import { useHasPermission } from '@spx-portal/shared-hooks';
import { isAdmin } from '@spx-portal/shared-utils';

export const usePermissions = () => {
  const stationViewPermission = useHasPermission('WORKFORCE_ROSTER_PLANNING_NEW_SHIFT');
  const stationCreatePermission = useHasPermission('WORKFORCE_ROSTER_PLANNING_NEW_SHIFT_CREATE');
  const stationEnableDisablePermission = useHasPermission('WORKFORCE_ROSTER_PLANNING_NEW_SHIFT_DISABLE_ENABLE');
  const stationEditPermission = useHasPermission('WORKFORCE_ROSTER_PLANNING_NEW_SHIFT_EDIT');
  const stationExportPermission = useHasPermission('WORKFORCE_ROSTER_PLANNING_NEW_SHIFT_EXPORT');
  const adminViewPermission = useHasPermission('ADMIN_WORKFORCE_ROSTER_PLANNING_NEW_SHIFT');
  const adminCreatePermission = useHasPermission('ADMIN_WORKFORCE_ROSTER_PLANNING_NEW_SHIFT_CREATE');
  const adminDeletePermission = useHasPermission('ADMIN_WORKFORCE_ROSTER_PLANNING_NEW_SHIFT_DELETE');
  const adminEditPermission = useHasPermission('ADMIN_WORKFORCE_ROSTER_PLANNING_NEW_SHIFT_EDIT');
  const adminExportPermission = useHasPermission('ADMIN_WORKFORCE_ROSTER_PLANNING_NEW_SHIFT_EXPORT');
  if (isAdmin()) {
    return {
      // view
      hasViewPermission: adminViewPermission,
      // 创建
      hasCreatePermission: adminCreatePermission,
      // delete
      hasDeletePermission: adminDeletePermission,
      // disable
      hasEditPermission: adminEditPermission,
      // export
      hasExportPermission: adminExportPermission,
    };
  }
  return {
    // view
    hasViewPermission: stationViewPermission,
    // 创建
    hasCreatePermission: stationCreatePermission,
    // enable/disable
    hasEnableDisablePermission: stationEnableDisablePermission,
    // disable
    hasEditPermission: stationEditPermission,
    // export
    hasExportPermission: stationExportPermission,
  };
};
